import React, { Component } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getCurrentWalletConnected } from '../utils'
import { GetClientTokenStandings } from '../data'
import Clock from './Clock'


class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );

      
  }
}

export default class Responsive extends Component {

  constructor() {
    super()
    this.connectedWallet()
    this.state = {
    }
    this.getBeneficiary()
  }

state = {
  walletAddress : '',
  total: 'total',
  locked: 'locked',
  available: 'available',
  releasePercent: 'percent',
  releaseDate: 'date',
  remainingTime:'how long before I request?',
}
  
connectedWallet = async () => {
  const wallet = await getCurrentWalletConnected()
  this.setState({
    walletAddress: wallet.address,
  })
  return wallet.address
}

getBeneficiary = async () => {

  try {
    await this.connectedWallet()
    const address = this.state.walletAddress
    if( address === undefined){
      alert("Address Not set yet!")
    }
    const data = await GetClientTokenStandings(address)
    this.setState({
        total: data.total,
        locked: data.locked,
        available: data.available,
        releasePercent: data.releasePercent,
        releaseDate: data.releaseDate.toString(),
    })
    return data
  } catch (error) {
    console.log(error.message)
  }
  return {}
}

  render() {
    
    var settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      adaptiveHeight: 300,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };

    return (
        <div className='nft-big'>
          <Slider {...settings}>
          <CustomSlide className='itm' index={5}>
              <div className="nft_pic"> 
              <h5 className="">
                <span className="text-uppercase color">Wallet: {this.state.walletAddress}</span>
              </h5>                           
                <h1>Account Summary</h1>
                <h4>Total AFER acquired : <span className="text-uppercase color">{this.state.total} AFER</span></h4>
                <h4>Amount Locked : <span className="text-uppercase color">{this.state.locked} AFER</span></h4>
                <h4>Amount Released/Available : <span className="text-uppercase color">{this.state.available} AFER</span></h4>
                <h4>Next Release Percent : <span className="text-uppercase color">{this.state.releasePercent}%</span></h4>
                <h4>Next Release Date : <span className="text-uppercase color">{this.state.releaseDate}</span></h4>
                <h4>Days Left : <span className="text-uppercase color"> <Clock deadline={this.state.releaseDate}/></span></h4>
              </div>
            </CustomSlide>
          </Slider>
        </div>
    );
  }
}
